import { AnimatePresence } from 'framer-motion';
import { FC, useState } from 'react';

import Text from '@/components/Text';
import Card, { ActionButton } from '@/pages/MLProject/components/Card';
import {
  Details,
  DetailsBlock,
  Label,
} from '@/pages/MLProject/components/MainInfoCard';

import TitleDescriptionForm from './TitleDescriptionForm';

interface Props {
  translationId: number;
  title?: string;
  description?: string;
  isDisabled: boolean;
}

const MainInfoTranslationsCard: FC<Props> = ({
  translationId,
  title,
  description,
  isDisabled,
}) => {
  const [showEditForm, setShowEditForm] = useState(false);

  return (
    <>
      <Card
        storageKey={`ml_translation_${translationId}_translation_card_visibility`}
        title="Translation"
        defaultIsOpened
        description="Add title and description translations"
        actions={
          <ActionButton
            $secondary
            onClick={() => setShowEditForm(true)}
            disabled={isDisabled}
          >
            Edit
          </ActionButton>
        }
      >
        <Details>
          <DetailsBlock>
            <Label>Title</Label>
            <Text $type="captionSemibold">{title ?? '-'}</Text>
          </DetailsBlock>
          <DetailsBlock>
            <Label>Description</Label>
            <Text $type="captionSemibold">{description ?? '-'}</Text>
          </DetailsBlock>
        </Details>
      </Card>
      <AnimatePresence>
        {showEditForm && (
          <TitleDescriptionForm
            title={title}
            description={description}
            translationId={translationId}
            onClose={() => setShowEditForm(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default MainInfoTranslationsCard;
